export enum CustomerPaymentType {
   Prepaid = 'Prepaid',
   Pai = 'Pai',
   Paipo = 'Paipo',
   Free = 'Free',
   Credits = 'Credits',
   Paiso = 'Paiso'
}


export namespace CustomerPaymentType {
   export function ToNumber(type: CustomerPaymentType): number {
      switch (type) {
         case CustomerPaymentType.Pai:
            return 2;
         case CustomerPaymentType.Paipo:
            return 3;
         case CustomerPaymentType.Free:
            return 4;
         case CustomerPaymentType.Credits:
            return 5;
         case CustomerPaymentType.Paiso:
            return 6;
         case CustomerPaymentType.Prepaid:
         default:
            return 1;
      }
   }

   export function FromNumber(type: number): CustomerPaymentType {
      switch (type) {
         case 2:
            return CustomerPaymentType.Pai;
         case 3:
            return CustomerPaymentType.Paipo;
         case 4:
            return CustomerPaymentType.Free;
         case 5:
            return CustomerPaymentType.Credits;
         case 6:
            return CustomerPaymentType.Paiso;
         case 1:
         default:
            return CustomerPaymentType.Prepaid;
      }
   }
}
